const DATABASE_NAME = 'palen.guest-question-lock';
const STORE_NAME = 'claim';

/** Serialize only the synchronous storage claim; no question data is stored here. */
export function withGuestQuestionClaimLock<T>(claim: () => T): Promise<T> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') { reject(new Error('Claim lock unavailable')); return; }
    let cancelled = false;
    const opening = indexedDB.open(DATABASE_NAME, 1);
    opening.onupgradeneeded = () => opening.result.createObjectStore(STORE_NAME);
    opening.onerror = () => reject(opening.error);
    opening.onblocked = () => { cancelled = true; reject(new Error('Claim lock blocked')); };
    opening.onsuccess = () => {
      const database = opening.result;
      if (cancelled) { database.close(); return; }
      let claimed = false;
      let result: T;
      const finish = () => {
        database.close();
        if (claimed) resolve(result);
        else reject(new Error('Claim lock unavailable'));
      };
      try {
        const transaction = database.transaction(STORE_NAME, 'readwrite');
        transaction.oncomplete = finish;
        transaction.onabort = finish;
        transaction.onerror = () => { /* Abort settles without repeating a completed storage claim. */ };
        transaction.objectStore(STORE_NAME).get('pending').onsuccess = () => {
          // A readwrite transaction owns this object store across all same-origin tabs.
          // Never await or hold it while sending the request.
          result = claim();
          claimed = true;
        };
      } catch (error) {
        database.close();
        reject(error);
      }
    };
  });
}
